
import mainPublic             from '../../core/main-public';
import genomePage             from '../pages/genome/genome-page';

if (document.readyState === 'loading') {
  // The DOM is still loading, set up the event listener
  document.addEventListener("DOMContentLoaded", () => {
    mainPublic.init();
    genomePage.init();
  });
} else {
  // The DOM has already loaded, initialize immediately
  mainPublic.init();
  genomePage.init();
}
